
/* global debounce */
if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.disclosure = this.closest('details');

      if (
        this.disclosure &&
        this.disclosure.matches('.cart-note-disclosure')
      ) {
        this.cartNoteToggle =
          this.disclosure.querySelector('.js-show-note');
      }

      this.field = this.querySelector('textarea[name="note"]');
      this.isSGSCartPage = Boolean(
        this.closest('.sgs-cart-redesign')
      );

      this.latestValue = this.field ? this.field.value : '';
      this.savedValue = this.latestValue;
      this.processing = false;
      this.retryNeeded = false;

      this.init();
    }

    init() {
      this.debouncedHandleNoteChange = debounce(
        this.handleNoteChange.bind(this),
        300
      );

      this.addEventListener('input', (event) => {
        if (!event.target.matches('textarea[name="note"]')) {
          return;
        }

        this.latestValue = event.target.value;
        this.debouncedHandleNoteChange(event);
      });

      this.addEventListener('focusout', (event) => {
        if (event.target.matches('textarea[name="note"]')) {
          this.handleNoteChange(event);
        }
      });
    }

    announce(status, note) {
      if (!this.isSGSCartPage) return;

      this.dispatchEvent(
        new CustomEvent('cart-note:status', {
          bubbles: true,
          detail: { status, note }
        })
      );
    }

    handleNoteChange(event) {
      if (
        event &&
        event.target &&
        event.target.value !== undefined
      ) {
        this.latestValue = event.target.value;
      }

      // Preserve the customized Swedish Gift Store heading.
      if (
        this.cartNoteToggle &&
        !this.isSGSCartPage &&
        typeof theme !== 'undefined' &&
        theme.strings
      ) {
        const label = this.latestValue
          ? theme.strings.editCartNote
          : theme.strings.addCartNote;

        if (this.cartNoteToggle.textContent !== label) {
          this.cartNoteToggle.textContent = label;
        }
      }

      if (
        this.latestValue === this.savedValue &&
        !this.retryNeeded
      ) {
        return;
      }

      this.announce('saving', this.savedValue);
      this.saveLatest();
    }

    async saveLatest() {
      if (this.processing) return;

      this.processing = true;

      try {
        while (
          this.latestValue !== this.savedValue ||
          this.retryNeeded
        ) {
          this.retryNeeded = false;

          const requestedNote = this.latestValue;

          const response = await fetch(
            theme.routes.cartUpdate,
            {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              credentials: 'same-origin',
              body: JSON.stringify({
                note: requestedNote
              })
            }
          );

          if (!response.ok) {
            throw new Error('Cart note update failed');
          }

          const cart = await response.json();

          if (cart.note !== requestedNote) {
            throw new Error('Cart note not confirmed');
          }

          this.savedValue = requestedNote;

          if (this.latestValue === this.savedValue) {
            this.announce('saved', this.savedValue);
          } else {
            this.announce('saving', this.savedValue);
          }
        }
      } catch (error) {
        this.retryNeeded = true;
        this.announce('error', this.savedValue);

        console.error('Unable to save cart note:', error);
      } finally {
        this.processing = false;
      }
    }
  }

  customElements.define('cart-note', CartNote);
}
